<template>
    <div
        class="wp-block-media-text"
        :class="{
            'has-media-on-the-right': reverse,
            'is-stacked-on-mobile': true
        }"
        :style="gridStyle"
    >
        <figure class="wp-block-media-text__media">
            <img :src="image" alt="" />
        </figure>
        <div class="wp-block-media-text__content">
            <h2 class="media-title">{{ title }}</h2>
            <p class="media-text">{{ content }}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "MediaText",
    props: {
        image: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        content: {
            type: String,
            required: true
        },
        reverse: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        gridStyle() {
            return {
                gridTemplateColumns: this.reverse ? "auto 40%" : "40% auto"
            };
        }
    }
};
</script>

<style scoped>
/* Add scoped styles here */
.media-title {
    color: #190d30;
    font-family: "FK Display", sans-serif;
    font-size: 32px;
    font-weight: 400;
    letter-spacing: -0.8px;
    line-height: 1.1;
    margin-bottom: 25px;
}

@media (min-width: 768px) {
    .media-title {
        font-size: 32px;
    }
}

@media (min-width: 992px) {
    .media-title {
        font-size: 32px;
    }
}

@media (min-width: 1200px) {
    .media-title {
        font-size: 55px;
        letter-spacing: -1.5px;
        margin-bottom: 25px;
    }
}
.media-text {
    color: #333;
    font-family: "Arial", sans-serif;
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 1.5;
    margin-bottom: 1rem;
}

@media (min-width: 1200px) {
    .media-text {
        font-size: 18px;
        letter-spacing: 0;
        margin-bottom: 1.5rem;
    }
}
</style>
